export default "__VITE_ASSET__jWt$u3ui__"